module.exports = __webpack_public_path__ + "b24e87d5/img/send-icon.3cfb6275.svg";